import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogBranchComponent } from './dialog-branch/dialog-branch.component';
import { DialogUserComponent } from './dialog-user/dialog-user.component';
import { DialogProductComponent } from './dialog-product/dialog-product.component';
import { SharedModulesModule } from '../../shared-modules/shared-modules.module';
import { DialogMemberListComponent } from './dialog-member-list/dialog-member-list.component';
import { DialogSuppilerComponent } from './dialog-suppiler/dialog-suppiler.component';
import { DialogMembertypeComponent } from './dialog-membertype/dialog-membertype.component';
import { DialogProducttypeComponent } from './dialog-producttype/dialog-producttype.component';
import { DialogChenalComponent } from './dialog-chenal/dialog-chenal.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { DialogCustomerbarcodeComponent } from './dialog-customerbarcode/dialog-customerbarcode.component';
import { DialogSaletodayComponent } from './dialog-saletoday/dialog-saletoday.component';
import { DialogWithholdingComponent } from './dialog-withholding/dialog-withholding.component';
import { DialogPromptpayComponent } from './dialog-promptpay/dialog-promptpay.component';
import { DialogService } from './dialog.service';
import { MemberModule } from '../work/member/member.module';
import { DialogProductSaleComponent } from './dialog-product-sale/dialog-product-sale.component';
import { DialogBranchAllComponent } from './dialog-branch2/dialog-branch.component';
@NgModule({
  declarations: [DialogBranchComponent,
    DialogBranchAllComponent,
    DialogUserComponent,
    DialogProductComponent,
    DialogMemberListComponent,
    DialogSuppilerComponent,
    DialogMembertypeComponent,
    DialogProducttypeComponent,
    DialogChenalComponent,
    ProgressBarComponent,
    DialogCustomerbarcodeComponent,
    DialogSaletodayComponent,
    DialogWithholdingComponent,
    DialogPromptpayComponent,
    DialogProductSaleComponent],
  imports: [
    CommonModule,
    SharedModulesModule,
    MatProgressSpinnerModule,
    
  ],
  providers: [
    DialogService
  ]
})
export class DialogModule { }
